const type = "UNSUBSCRIBE/";

export const unsubscribeConstants = {
  SAVE_SUCCESS: `${type}SAVE_SUCCESS`,
  SAVE_FAILURE: `${type}SAVE_FAILURE`,
  SAVE_REQUEST: `${type}SAVE_REQUEST`,
};
